interface TimeBasedData {
  time: number;
  [rowerKey: string]: number;
}

interface IntervalBasedData {
  interval: string;
  [rowerKey: string]: string | number;
}

/**
 * Transforms time-based telemetry data to interval-based data for animated charts
 * Converts { time: number, ...rowers } to { interval: string, ...rowers }
 */
export function transformTimeDataToIntervals(data: TimeBasedData[]): IntervalBasedData[] {
  if (!data || data.length === 0) {
    return [];
  }

  return data.map((item) => {
    const { time, ...rowerData } = item;

    // Convert time to formatted interval string
    const interval = formatTimeInterval(time);

    return {
      interval,
      ...rowerData,
    };
  });
}

/**
 * Formats time in seconds to a human-readable interval string
 * - Under 60 seconds: "1.5s", "0.02s"
 * - 60+ seconds: "1:00", "2:05"
 */
function formatTimeInterval(timeInSeconds: number): string {
  if (timeInSeconds < 60) {
    // For times under 60 seconds, show as decimal seconds
    if (timeInSeconds % 1 === 0) {
      // Whole seconds
      return `${timeInSeconds}.0s`;
    } else {
      // Decimal seconds, round to 2 decimal places
      return `${timeInSeconds.toFixed(2).replace(/\.?0+$/, '')}s`;
    }
  } else {
    // For times 60+ seconds, show as MM:SS
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
